import React, { useEffect, useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import SapCard from "./../Components/SapCard";
import './index.css';
import { api } from '../../services/api.js';
import Loading from "../../comum/Layout/loading.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';


import Menu from "../../comum/Menu/index.jsx";
import Footer from '../../comum/Footer/index.jsx';
import Avaliacao from "../Avaliacao/index.jsx";

function Sap() {
    const { chapa } = useParams();
    const [tabelas, setTabelas] = useState([]);
    const [comprador, setComprador]     = useState(0);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [aprovacao, setAprovacao] = useState(false);
    const [negacao, setNegacao] = useState(false);
    const [confirmacaoId, setConfirmacaoId] = useState('');
    const [atualizado, setAtualizado] = useState('');
    const [nome, setNome] = useState('');
    const [erro, setErro] = useState('');
    const [datahora, setData] = useState('');

    const [sucesso, setSucesso] =useState(true);
//variaveis para envio do SAP
    const[sap_loja, setSap_Loja]        = useState(0);
    const[sap_codigo, setSap_Codigo]    = useState(0);
    const[sap_data, setSap_data]        = useState('');
    const[sap_inicio, setSap_Inicio]    = useState('');
    const[sap_fim, setSap_Fim]          = useState('');
    const [sap_preco, setSap_Preco]   = useState('');
    const [sap_sequencia, setSap_Sequencia]   = useState('');
    const [sap_descricao, setSap_Descricao]   = useState('');



    let state = { mostrarComponente: false };
    function handleClick() {
        this.setState({
            mostrarComponente: true
        });
    }

    //funcao para mudar data
    function MudarData() {
        const newdata = new Date().toLocaleTimeString();
        setData(newdata);
    }
    //setTimeout(MudarData, 60000);  

    function confirmAprovar(data,loja,sequencia,codigo,descricao, preco) {
        setAprovacao(true);
        setConfirmacaoId(chapa);
        setNome(nome);
        setSap_Sequencia(sequencia);
        setSap_Loja(loja);
        setSap_Codigo(codigo);
        setSap_data(data);
        setSap_Preco(preco);
        setSap_Descricao(descricao);
    }

    function confirmNegar(data,loja,sequencia,codigo, descricao,preco) {
        setNegacao(true);
        setConfirmacaoId(chapa);
        setNome(nome);
        setSap_Sequencia(sequencia);
        setSap_Loja(loja);
        setSap_Codigo(codigo);
        setSap_data(data);
        setSap_Preco(preco);
        setSap_Descricao(descricao);
    }

    //post atualizar
    function aprovaSAP() {
        setAprovacao(false);
        setNegacao(false);
        setAtualizado('');
        const data = ({
            chapa,
            sequencia: sap_sequencia,
            loja:sap_loja,
            codigo:sap_codigo,
            datasol:sap_data,
            inicio:null,
            fim:null,
            preco:sap_preco,
            status: "A"
        });    
        console.log(data);

        api.post('/SAP/atualiza' ,data,)
            .then(async (retorno) => {
                await
                  setAtualizado(chapa);
                  setRemoveLoading(true)
            })
            .catch((err) => {
                setErro("Erro na liberação:" + err);
                setRemoveLoading(true);

            });
    }

    function negaSAP(motivo) {   
            setAtualizado('');    
            setNegacao(false);
            const data = ({
                chapa,
                sequencia: sap_sequencia,
                loja:sap_loja,
                codigo:sap_codigo,
                datasol:sap_data,
                inicio:null,
                fim:null,
                preco: 0,
                status: "N",
                motivo     
            });
            console.log(data);
            
            api.post('/SAP/atualiza', data, {
            })
            .then(response => {
               setSucesso(true);
               setAtualizado(chapa);
               setRemoveLoading(true)
            })
            .catch(error => {
                setErro(error.response.data.erro);
                console.log(error);
                // {"erro": "Informe o valor"}
            });
        }



    useEffect(() => {
        setRemoveLoading(false)
        setErro('');
        api.get('/SAP/consulta/ssss' + chapa)
            .then(response => {
                setTabelas(response.data);
                setRemoveLoading(true);
            })
            .catch(err => {
                setRemoveLoading(true);
                setErro(err.response.data.erro);
            });
    }, [comprador,datahora,atualizado]);


   {/* useEffect(() => {
        PesquisarPermissaoSAP();
    }, []);*/}

    return (<div>
        <Menu />

        <div className="pagina-home ">
            <div className="container-fluid ">

                <div className="row">
                    <div className="col-md-5">
                        <h5></h5>
                    </div>
                </div>
                {/*<div className="col-md-7">
                    <div className="input-group mb-3">
                        {/*<label className="text-secondary lbl">{datahora===''? null : `Atualizado: ${datahora}`}</label>*/}
                  {/*}      <button onClick={MudarData} className="btn btn-outline-danger" type="button" id="button-busca"><i className="fa fa-refresh"></i> {datahora === "" ? "Aguardando" : `Atualizado: ${datahora}`} </button>
                    </div>
                </div>*/}
                {!removeLoading && <Loading />}

                {/*

                    <div className="col-md-7">
                        <div className="input-group mb-3">
                            <input onChange={(e) => setTexto(e.target.value)} type="text" className="form-control" placeholder="Loja" aria-describedby="button-addon2" />
                            <button onClick={(e) => setPesquisa('?loja=' + texto)} className="btn btn-outline-danger" type="button" id="button-busca"><i className="fas fa-search"></i> Pesquisar</button>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 mt-2">
                    <div className="card text-white bg-secondary">
                           <div className="card-header">
                                Setor
                            </div>                        
                            <div className="card-body mb-12">
                                <select className="sel-item" name="setor" id="setor" onChange={(e) => setPesquisa(e.target.value)} value={1}>
                                    <option value="0">Selecione um Setor</option>
                                    {lista_lojas.map(lj => {
                                        return <option key={lj.loja} value={lj.loja}>{lj.loja}</option>
                                    })}                            
                                </select>   
                            </div>                             
                    </div>    
                </div>*/}

                <div className="row">
                    {
                        tabelas.map((tabela) => {
                            return <div className="col-lg-2 col-md-12 col-sm-12 col-6" key={tabela.chapa}>
                                <SapCard 
                                    clickAprovar={confirmAprovar}
                                    clickNegar = {confirmNegar}
                                    sap_data        ={tabela.sap_data}
                                    sap_loja        ={tabela.sap_loja}
                                    sap_sequencia   ={tabela.sap_sequencia}
                                    sap_codigo      ={tabela.sap_codigo}
                                    sap_descricao   ={tabela.sap_descricao}
                                    sap_emb         ={tabela.sap_emb}
                                    sap_estoque     ={tabela.sap_estoque}
                                    sap_custo       ={tabela.sap_custo}
                                    sap_preco       ={tabela.sap_preco}
                                    sap_precopromo  ={tabela.sap_precopromo}
                                    sap_precoapp    ={tabela.sap_precoapp}
                                    sap_precoconcorrente={tabela.sap_precoconcorrente}
                                    sap_precosolicitado={tabela.sap_precosolicitado}
                                    sap_precoautorizado={tabela.sap_precoautorizado}
                                    sap_inicio      ={tabela.sap_inicio}
                                    sap_fim         ={tabela.sap_fim}
                                    sap_qtde        ={tabela.sap_qtde}
                                    sap_motivo      ={tabela.sap_motivo}
                                    sap_observacao  ={tabela.sap_observacao}
                                    sap_movimentacao={tabela.sap_movimentacao}
                                    sap_processado  ={tabela.sap_processado}
                                    sap_status      ={tabela.sap_status}
                                    sap_comprador   ={tabela.sap_comprador}
                                    sap_nomecomprador={tabela.sap_nomecomprador}
                                    matricula       = {tabela.matricula}
                                    nome            ={tabela.nome}
                                    funcao          ={tabela.funcao}
                                    informacao      ={tabela.informacao}
                                    ean             ={tabela.ean}
                                />
                            </div>;
                        })
                    }
                </div>
                {/*APROVAR*/}
                {aprovacao ?
                    <SweetAlert
                        success
                        showCancel
                        showCloseButton
                        confirmBtnText="Sim"
                        confirmBtnBsStyle="success"
                        cancelBtnText="Não"
                        cancelBtnBsStyle="danger"
                        title="Confirmação"
                        onConfirm={() => aprovaSAP(confirmacaoId)}
                        onCancel={() => setAprovacao(false)}
                        reverseButtons={false}
                        openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                        closeAnim={{ name: 'hideSweetAlert', duration: 100 }}
                    >   {sap_descricao} pelo preço de {sap_preco}?
                    </SweetAlert> : null
                }
                {/*NEGAR*/}
                {negacao ?
                    <SweetAlert
                        input
                        showCancel
                        showCloseButton
                        confirmBtnText="Confirmar"
                        confirmBtnBsStyle="success"
                        cancelBtnText="Cancelar"
                        cancelBtnBsStyle="danger"
                        title="Motivo"
                        onConfirm={(response) => negaSAP(response)}
                        onCancel={() => setNegacao(false)}
                        reverseButtons={false}
                        openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                        closeAnim={{ name: 'hideSweetAlert', duration: 100 }}
                    >   Informe o motivo de negar o preço {sap_preco} do produto {sap_descricao}!
                    </SweetAlert> : null
                }
                {/*erro*/}
                {
                    erro ==='' ?
                        null
                        :
                        <SweetAlert
                            danger
                            showCloseButton
                            confirmBtnText="OK"
                            confirmBtnBsStyle="danger"
                            onConfirm={() => setErro('')}
                            title="Falha"
                            reverseButtons={false}
                            openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                            closeAnim={{ name: 'hideSweetAlert', duration: 100 }}
                        >   Erro: {erro}
                        </SweetAlert>
                }
            </div>

            {removeLoading && <Footer className="footer navbar-fixed-bottom" />}

        </div>
    </div>
    );
}

export default Sap;